import React from "react"
import PropTypes from "prop-types"
import applePayIcon from "assets/imagesV2/payment-methods/apple-pay.svg"
import creditCardIcon from "assets/imagesV2/payment-methods/credit-card.svg"
import googlePayBase from "assets/imagesV2/payment-methods/google-pay-base.svg"
import googlePayOutline from "assets/imagesV2/payment-methods/google-pay-outline.svg"
import googlePayTypeface from "assets/imagesV2/payment-methods/google-pay-typeface.svg"
import googlePayMark from "assets/imagesV2/payment-methods/google-pay-g-mark.svg"
import { PAYMENT_METHODS } from "./payment"
import styles from "./WidgetCheckout.module.css"

// Payment method marks from the design. The Google Pay mark is four layers placed in a 40px box.
const PaymentMethodIcon = ({ method }) => {
  if (method === PAYMENT_METHODS.googlePay) {
    return (
      <span className={styles.methodBadge}>
        <span className={styles.googlePayBox}>
          <img src={googlePayBase} alt="" width="40" height="21.2507" className={styles.googlePayBase} />
          <img src={googlePayOutline} alt="" width="40" height="21.2507" className={styles.googlePayBase} />
          <img src={googlePayTypeface} alt="" width="15.8562" height="10.3225" className={styles.googlePayTypeface} />
          <img src={googlePayMark} alt="" width="8.92199" height="9.10022" className={styles.googlePayMark} />
        </span>
      </span>
    )
  }
  if (method === PAYMENT_METHODS.applePay) {
    return (
      <span className={styles.methodBadge}>
        <img src={applePayIcon} alt="" width="32" height="32" />
      </span>
    )
  }
  return (
    <span className={styles.methodBadge}>
      <img src={creditCardIcon} alt="" width="20" height="20" />
    </span>
  )
}

PaymentMethodIcon.propTypes = {
  method: PropTypes.oneOf(Object.values(PAYMENT_METHODS)).isRequired
}

export default PaymentMethodIcon
